import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { useHistory, useLocation, useParams } from "react-router-dom";
import * as Yup from "yup";
import { TextInput } from "../../../commons/formik";
import { ACCOUNT_INFORMATION, ACCOUNT } from "../../../constants";
import { ButtonContainer, Button } from "../../../commons/elements";

const propTypes = {
  clientId: PropTypes.number.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    username: PropTypes.string,
    password: PropTypes.string
  }).isRequired,
  editAccount: PropTypes.func.isRequired,
  // Map state to props
  isSubmitting: PropTypes.bool.isRequired
};

function EditPersonalInfoForm(props) {
  const { clientId, user, editAccount, isSubmitting } = props;
  const history = useHistory();
  const location = useLocation();
  const params = useParams();

  const initialValues = {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email || user.username,
    password: user.password,
    confirmPassword: user.password
  };

  const EditAccountSchema = Yup.object().shape({
    firstName: Yup.string().required("Please enter your first name"),
    lastName: Yup.string().required("Please enter your last name"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Please enter a valid email"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .matches(
        /(?:[A-Z].*[0-9])|(?:[0-9].*[A-Z])/g,
        "Include at least one upper case letter and a number"
      ),
    confirmPassword: Yup.mixed().oneOf(
      [Yup.ref("password"), null],
      "Passwords don't match"
    )
  });

  const handleSubmit = (values) => {
    editAccount({
      ...values,
      clientId,
      id: user.id,
      history,
      location,
      shortName: params.shortName
    });
  };

  return (
    <div className="form-container">
      <Formik
        initialValues={initialValues}
        validationSchema={EditAccountSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isValid, dirty }) => (
          <Form>
            <div className="d-flex flex-column">
              <TextInput
                id="edit-first-name"
                label="First Name"
                name="firstName"
                type="text"
                placeholder="First Name"
                labelProps={{ className: "lbl-first-name" }}
              />
              <TextInput
                id="edit-last-name"
                label="Last Name"
                name="lastName"
                type="text"
                placeholder="Last Name"
                labelProps={{ className: "lbl-last-name" }}
              />
              <TextInput
                id="edit-email"
                label="Email"
                name="email"
                type="email"
                placeholder="example@email.com"
                isDisabled="true"
                labelProps={{ className: "lbl-email" }}
              />
              <TextInput
                id="edit-account-password"
                label="Password"
                name="password"
                type="password"
                placeholder="password"
                labelProps={{ className: "lbl-password" }}
              />
              <TextInput
                id="edit-account-confirm-password"
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                placeholder="password"
                labelProps={{ className: "lbl-confirm-password" }}
              />
            </div>
            <ButtonContainer>
              <Button
                className="cancel-btn"
                label="Cancel"
                disabled={isSubmitting}
                onClick={() =>
                  history.push(
                    `/${params.shortName}/${ACCOUNT}/${ACCOUNT_INFORMATION}${location.search}`
                  )
                }
              />
              <Button
                type="submit"
                label="Save"
                disabled={!(isValid && dirty) || isSubmitting}
                isSubmitting={isSubmitting}
              />
            </ButtonContainer>
          </Form>
        )}
      </Formik>
    </div>
  );
}

EditPersonalInfoForm.propTypes = propTypes;

const mapStateToProps = (state) => ({
  isSubmitting: state.user.isSubmitting
});

export default connect(mapStateToProps)(EditPersonalInfoForm);
